const TEMPLATE_HEADERS = [
  'Year',
  'State',
  'IssuerID',
  'SourceName',
  'HiosPlanID',
  'ServiceAreaID',
  'ServiceAreaName',
  'CoverEntireState',
  'CountyCode',
  'PartialCounty',
  'Zipcode',
  'IsActive',
]

export function downloadServiceAreaTemplate(): void {
  const csv = TEMPLATE_HEADERS.join(',')
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = 'service-area-template.csv'
  link.click()
  URL.revokeObjectURL(url)
}
